import { taskPassesFilters } from './applyFilters'
import type { FilterContext } from './applyFilters'
import type { TaskFilter } from '@/lib/types/filter'
import type { TaskDocument } from '@/lib/db/rxdb/schemas/task'

export type StrictestFilter = {
  filter: TaskFilter
  /** How many tasks show if only this filter is removed. */
  countWithout: number
}

/**
 * When filters leave nothing, find the one whose removal brings back the most
 * tasks (design 9c: "say which filter is too strict, and offer the fix").
 * Returns null when no single removal helps.
 */
export function findStrictestFilter(
  tasks: ReadonlyArray<TaskDocument>,
  filters: ReadonlyArray<TaskFilter>,
  context: FilterContext = {},
): StrictestFilter | null {
  const active = filters.filter((f) => f.values.length > 0)
  let best: StrictestFilter | null = null
  for (const filter of active) {
    const others = active.filter((f) => f !== filter)
    const countWithout = tasks.filter((task) => taskPassesFilters(task, others, context)).length
    if (countWithout > 0 && (!best || countWithout > best.countWithout)) {
      best = { filter, countWithout }
    }
  }
  return best
}
